export default {
	basename: process.env.REACT_APP_ROUTE_BASENAME,
	apiBaseUrl: process.env.REACT_APP_API_BASE_URL,
	apiUrl: process.env.REACT_APP_API_URL,
	environment: process.env.REACT_APP_ENVIRONMENT,
	pdftronLicenseKey: process.env.PDFTRON_LICENSE_KEY,
	webviewerPath: process.env.WEBVIEWER_PATH,
	s3BucketLawyawStaticUrl: process.env.AWS_S3_BUCKET_LAWYAW_STATIC_URL,
};
